var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99996 3.98317C10.69 3.98317 11.83 4.71317 12.48 5.32317L15.02 2.84317C13.46 1.39317 11.43 0.503174 8.99996 0.503174C5.47996 0.503174 2.43996 2.52317 0.959961 5.46317L3.86996 7.72317C4.59996 5.55317 6.61996 3.98317 8.99996 3.98317Z",
    fill: "#EA4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.64 9.70328C17.64 8.96328 17.58 8.42328 17.45 7.86328H9V11.2033H13.96C13.86 12.0333 13.32 13.2833 12.12 14.1233L14.96 16.3233C16.66 14.7533 17.64 12.4433 17.64 9.70328Z",
    fill: "#4285F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88 11.2831C3.69 10.7231 3.58 10.1231 3.58 9.50313C3.58 8.88313 3.69 8.28313 3.87 7.72313L0.96 5.46313C0.35 6.68313 0 8.05313 0 9.50313C0 10.9531 0.35 12.3231 0.96 13.5431L3.88 11.2831Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99997 18.5032C11.43 18.5032 13.47 17.7032 14.96 16.3232L12.12 14.1232C11.36 14.6532 10.34 15.0232 8.99997 15.0232C6.61997 15.0232 4.59997 13.4532 3.87997 11.2832L0.969971 13.5432C2.44997 16.4832 5.47997 18.5032 8.99997 18.5032Z",
    fill: "#34A853"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.744cede214e37062321debff42f2d4e7.svg";
export { ForwardRef as ReactComponent };